import { useState } from "react"

import { useTranslation } from "react-i18next"

import { usePartnerCode } from "@/features/PartnerCode"

export const usePartnerCodeInput = () => {
  const { t } = useTranslation()
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [error, setError] = useState<string | undefined>()

  const { setPartnerCode } = usePartnerCode()
  const [code, setCode] = useState("")

  const openDialog = () => {
    setIsDialogOpen(true)
  }

  const closeDialog = () => {
    setIsDialogOpen(false)
    // Reset error state when dialog is closed
    setError(undefined)
  }

  const handleCodeChange = (value: string) => {
    setCode(value)
    // Clear error when user starts typing and has valid input
    if (error && value.trim()) {
      setError(undefined)
    }
  }

  const submitCode = () => {
    if (!code.trim()) {
      setError(t("partnerCodeInput.errorMessage"))
      return
    }

    setError(undefined)
    setPartnerCode(code.trim())
    setCode("")
    closeDialog()
  }

  return {
    isDialogOpen,
    code,
    error,
    openDialog,
    closeDialog,
    handleCodeChange,
    submitCode,
  }
}
